import { render, staticRenderFns } from "./PurchaseOrdersActions.vue?vue&type=template&id=19b8e35e&scoped=true&"
import script from "./PurchaseOrdersActions.vue?vue&type=script&lang=js&"
export * from "./PurchaseOrdersActions.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseOrdersActions.vue?vue&type=style&index=0&id=19b8e35e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b8e35e",
  null
  
)

export default component.exports